@if (headerVariant() === 'storefront') {
  <header class="header storefront">
    <div class="header-inner">
      <img
        src="assets/logos/oss-logo.png"
        class="logo oss-logo"
        alt="OSS"
        routerLink="/home/nola-driver"
      />

      <div class="menu-toggle" (click)="toggleMenu()">
        <mat-icon>{{ isMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </div>

      <nav class="nav desktop-nav">
        @if (!isLoggedIn()) {
          <div class="city-dropdown">
            <button class="city-button" (click)="toggleCityMenu()">
              {{
                currentCity() === 'nola'
                  ? 'New Orleans, LA'
                  : currentCity() === 'balt'
                    ? 'Baltimore, MD'
                    : 'St. George, LA'
              }}
              <mat-icon>expand_more</mat-icon>
            </button>

            @if (isCityMenuOpen()) {
              <div class="city-menu">
                <a routerLink="/home/nola-driver" (click)="closeMenu()">New Orleans, LA</a>
                <a routerLink="/home/balt-driver" (click)="closeMenu()">Baltimore, MD</a>
                <a routerLink="/home/stg-driver" (click)="closeMenu()">St. George, LA</a>
              </div>
            }
          </div>

          <a routerLink="/incident-request-search" routerLinkActive="active">Request Content</a>

          <a class="login" routerLink="/auth" routerLinkActive="active">Login</a>
        } @else {
          <a routerLink="/admin/incident-request-search" routerLinkActive="active">
            Incident Requests
          </a>

          <a class="logout" (click)="logoutAsync()">Logout</a>
        }
      </nav>
    </div>

    @if (isMenuOpen()) {
      <nav class="nav mobile-nav">
        @if (!isLoggedIn()) {
          <div class="city-dropdown">
            <button class="city-button" (click)="toggleCityMenu()">
              {{
                currentCity() === 'nola'
                  ? 'New Orleans, LA'
                  : currentCity() === 'balt'
                    ? 'Baltimore, MD'
                    : 'St. George, LA'
              }}
              <mat-icon>expand_more</mat-icon>
            </button>

            @if (isCityMenuOpen()) {
              <div class="city-menu">
                <a routerLink="/home/nola-driver" (click)="closeMenu()">New Orleans, LA</a>
                <a routerLink="/home/balt-driver" (click)="closeMenu()">Baltimore, MD</a>
                <a routerLink="/home/stg-driver" (click)="closeMenu()">St. George, LA</a>
              </div>
            }
          </div>

          <a routerLink="/incident-request-search" (click)="closeMenu()">Request Content</a>

          <a class="login" routerLink="/auth" (click)="closeMenu()">Login</a>
        } @else {
          <a
            routerLink="/admin/incident-request-search"
            routerLinkActive="active"
            (click)="closeMenu()"
          >
            Incident Requests
          </a>

          <a class="logout" (click)="logoutAsync()">Logout</a>
        }
      </nav>
    }
  </header>
}

@if (headerVariant() === 'nola-dashboard') {
  <mat-toolbar class="toolbar">
    <img src="assets/logos/oss-logo.png" class="logo oss-logo" alt="OSS" />
    <span class="title">New Orleans Performance</span>
    <img src="assets/logos/nopd-logo.png" class="logo nopd-logo" alt="NOPD" />
  </mat-toolbar>
}

@if (headerVariant() === 'stg-dashboard') {
  <mat-toolbar class="toolbar">
    <img src="assets/logos/oss-logo.png" class="logo oss-logo" alt="OSS" />
    <span class="title">St. George Performance</span>
    <img src="assets/logos/stgpd-logo.png" class="logo nopd-logo" alt="SGPD" />
  </mat-toolbar>
}
